
import {mergeMap, map} from 'rxjs/operators';
import { Component } from '@angular/core';
import { MatSnackBar,MatDialog } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { FourDService } from '4d-mapper';
import { AppService } from '../commons/app.service';
import { TranslateService } from '@ngx-translate/core';
import {BaseComponent} from '../commons/BaseComponent';

import { XsApplicationEventsService } from '../xs/services/events/application-events.service';
import { LoadingSpinner } from '../commons/ui/loading-spinner';

@Component({
    selector: 'activate-comp',
    templateUrl: './activate.component.html'

})
export class ActivateComponent extends BaseComponent {

    accountUID:string
    groupUID:string
    token:string
    user:any
    error:string
    password2:string
    terms:boolean
    constructor(public appService:AppService, private fourd:FourDService, public service:FourDService,public router:Router, private ar:ActivatedRoute, 
        public snackBar: MatSnackBar, public dialog: MatDialog, public translate: TranslateService, applicationEvents:XsApplicationEventsService){
        super(router, snackBar, dialog)
        ar.params.subscribe(p => {
            this.token      = p.token
            this.accountUID = p.account

            this.service.V.api('/access/activate/' + p.token).subscribe(
                res => {
                    this.user = res
                    // Check if user is not active ignore the name attribute as it may contain dummy names to let the user set it
                    this.user.name = ""
                },e =>
                    this.error = e
            )
        })

    }
    activate(){
        this.loading = true
        this.user.name = this.user['first_name'] + ' ' + this.user['last_name']
        this.service.V.api('/access/activate/' + this.token,'post',this.user).subscribe(
            res => {
                // reset the client id (in case they used a share link prior)
                this.service.V.config.clientId = '4dmapper'

                // If user is active means it is a registered user so redirect to main page to auth or continue to app
                if (this.user.active) {
                    this.loading = false
                
                    var message
                    var action
                    this.translate.get(['SIGNIN.JOIN_SUCCESS','GENERIC.OK']).pipe(
                        map(params => {
                            message = params['SIGNIN.JOIN_SUCCESS']
                            action = params['GENERIC.OK']
                        }),mergeMap(e => {
                            return this.openDialog(message, null, action)
                        }),).subscribe(res => {
                            if (res){
                                // if invite result of account invite and user exists, server will set their last account
                                // to the new invited one, you just need to reload state in case they are already logged in
                                if(this.user.account && this.fourd.activeUser){
                                    this.fourd.teams = null
                                    this.fourd.onReady().subscribe(s => 
                                        this.router.navigate(['app'])
                                    )
                                }
                                // if invite not result of account
                                else{
                                    this.router.navigate(['app'])
                                }
                            
                            }
                        })
                } else {
                    this.service.V.loginWithUsernameObservable(this.user.username,this.user.password).pipe(
                        mergeMap(res => this.appService.refreshMe()),
                        mergeMap(res => this.appService.refreshData()),)
                        .subscribe(
                            res => {
                                this.router.navigate(['app'])
                            },e => {
                                this.loading = false;
                                LoadingSpinner.end();
                                console.log(e)
                                this.error = e
                            }
                        )
                }
            },e => {
               this.loading = false;
               LoadingSpinner.end();
               this.error = e
               console.log(this.error)
           }
        )
    }
    ngOnInit() {
        LoadingSpinner.end();
    }
}
